module.exports = __webpack_public_path__ + "static/img/fish14.e23f2d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish14.png
// module id = hBoj
// module chunks = 0